import {
  MasterCard,
  MasterPass,
  OzowTextIcon,
  Amex,
  DinersClub,
  Snapscan,
  Visa,
  GreyVodapayText,
  Zapper,
} from 'src/assets/images';

export const vatPercent: number = 0.15;

export const BUSINESS_TYPE_KEY_TO_NAME_LOOKUP = {
  sole_prop: 'Sole Proprietorship',
  partnership: 'Partnership',
  company: 'Company',
  close_corp: 'Close Corporation',
  non_profit_org: 'NPO',
  trust: 'Trust',
};

export const OnboardingDocumentType = {
  ID_TYPE: 'ID',
  BANK_PROOF_TYPE: 'Proof of bank account letter',
  COMPANY_RES_TYPE: 'Resolution letter',
  NPO_FOUNDING_TYPE: 'NPO founding documentation',
  TRUST_DEED_TYPE: 'Trust deed',
  TRUST_RES_TYPE: 'Resolution letter',
  RESIDENCE_TYPE: 'Proof of residence',
  OLD_GREEN_IDENTITY_DOCUMENT_TYPE: 'Old Green Identity Document',
  NEW_IDENTITY_CARD_TYPE: 'New Identity Card',
  PASSPORT_TYPE: 'Passport',
  WORK_PERMIT_TYPE: 'Work Permit',
  PERMANENT_RESIDENCY_TYPE: 'Permanent Residency',
  FOREIGN_NATIONAL_ID_DOC: 'Foreign National ID Document',
  REFUGEE_LETTER: 'Refugee Letter',
  ASYLUM_SEEKER: 'Asylum Seeker',
};

export const PRODUCT_IMAGE_LIST = {
  'Visa/ Mastercard': [MasterCard, Visa],
  'American Express/ Diners': [Amex, DinersClub],
  'Instant EFT (Ozow)': [OzowTextIcon],
  'QR (Scan to Pay)': [MasterPass, GreyVodapayText, Zapper, Snapscan],
};

export const PAYMENT_LIST = {
  'Visa/ Mastercard': {
    salesforceTitle: 'Visa/ Mastercard',
    title: 'Credit & debit cards',
    subtitle: 'Accept debit or credit card payments',
    id: 'card',
    subIcons: PRODUCT_IMAGE_LIST['Visa/ Mastercard'],
  },
  'American Express/ Diners': {
    salesforceTitle: 'American Express/ Diners',
    title: 'International cards',
    subtitle: 'Accept International cards payments on your website',
    id: 'intCard',
    subIcons: PRODUCT_IMAGE_LIST['American Express/ Diners'],
  },
  'Instant EFT (Ozow)': {
    salesforceTitle: 'Instant EFT (Ozow)',
    title: 'OZOW',
    subtitle: 'Accept Instant EFT payments with Ozow',
    id: 'ozow',
    subIcons: PRODUCT_IMAGE_LIST['Instant EFT (Ozow)'],
  },
  'QR (Scan to Pay)': {
    salesforceTitle: 'QR (Scan to Pay)',
    title: 'QR codes',
    subtitle: 'Accept Scan to Pay payments using most mobile wallets and apps',
    id: 'qr',
    subIcons: PRODUCT_IMAGE_LIST['QR (Scan to Pay)'],
  },
};

export const SOV_DETAILS = {
  Occupations: [
    'Unemployed',
    'General Worker',
    'Administrator',
    'Student',
    'Manager',
    'Consultant',
    'Sales',
    'Accounting',
    'Estate Agent',
    'IT',
    'Construction Work',
    'Civil Servant (Government)',
    'Army Other',
    'Gardener',
    'Shop Assistant',
    'Hair or Beauty Salon Assistant',
    'Hospitality industry',
    'Merchant',
    'Tradesman',
    'Street Trader',
    'Media',
    'Miner',
    'House Help',
    'Agricultural Worker',
    'Temp./Contract Worker',
    'Arts and culture',
    'Self employed',
    'Charitable Body',
    'Driver',
    'Medical',
    'Policing other',
    'Other',
  ],
  SourceOfFunds: [
    'Employment',
    'Investment',
    'Securities',
    'Pension',
    'Grants',
    'Inheritance',
    'Entertainment',
    'Gift/Donation',
    'Income from sales of services',
  ],
  SourceOfWealth: [
    'Securities investments',
    'Inheritance',
    'Divorce settlement',
    'Sale of business or other principal asset',
    'Sale of investments',
    'Savings',
    'Employment',
    'Income from Sales and services',
  ],
  BizWalletProInformation: {
    accountNumber: '9099610',
    walletLimit: '100000',
    dailyLimit: '20000',
  },
};

export const BankAccountTypes = [
  { value: 'CURRENT_CHEQUE', label: 'Current Cheque Account' },
  { value: 'SAVINGS', label: 'Savings' },
];

export const NATURE_OF_BUSINESS = [
  {
    broadCategory: 'Airlines',
    categories: [
      { description: 'United Airlines', mcc: '3000' },
      { description: 'American Airlines', mcc: '3001' },
      { description: 'Pan American', mcc: '3002' },
      { description: 'Eurofly Airlines', mcc: '3003' },
      { description: 'Trans World Airlines', mcc: '3004' },
      { description: 'British Airways', mcc: '3005' },
      { description: 'Japan Air Lines', mcc: '3006' },
      { description: 'Air France', mcc: '3007' },
      { description: 'Lufthansa', mcc: '3008' },
      { description: 'Air Canada', mcc: '3009' },
      { description: 'Royal Dutch Airlines (KLM)', mcc: '3010' },
      { description: 'Aeroflot', mcc: '3011' },
      { description: 'Qantas', mcc: '3012' },
      { description: 'Alitalia', mcc: '3013' },
      { description: 'Saudi Arabian Airlines', mcc: '3014' },
      { description: 'Swissair', mcc: '3015' },
      { description: 'Scandinavian Airline System (SAS)', mcc: '3016' },
      { description: 'South African Airways', mcc: '3017' },
      { description: 'Varig (Brazil)', mcc: '3018' },
      { description: 'Air India', mcc: '3020' },
      { description: 'Air Algerie', mcc: '3021' },
      { description: 'Philippine Airlines', mcc: '3022' },
      { description: 'Mexicana', mcc: '3023' },
      { description: 'Pakistan International', mcc: '3024' },
      { description: 'Air New Zealand Limited International', mcc: '3025' },
      { description: 'Emirates Airlines', mcc: '3026' },
      { description: 'Union de Transports Aeriens', mcc: '3027' },
      { description: 'Air Malta', mcc: '3028' },
      { description: 'Sabena', mcc: '3029' },
      { description: 'Aerolineas Argentinas', mcc: '3030' },
      { description: 'Olympic Airways', mcc: '3031' },
      { description: 'El Al', mcc: '3032' },
      { description: 'Ansett Airlines', mcc: '3033' },
      { description: 'Australian Airways (TAA)', mcc: '3034' },
      { description: 'Tap (Portugal)', mcc: '3035' },
      { description: 'VASP (Brazil)', mcc: '3036' },
      { description: 'EgyptAir', mcc: '3037' },
      { description: 'Kuwait Airways', mcc: '3038' },
      { description: 'Avianca', mcc: '3039' },
      { description: 'Gulf Air (Bahrain)', mcc: '3040' },
      { description: 'Balkan', mcc: '3041' },
      { description: 'Finnair', mcc: '3042' },
      { description: 'Aer Lingus', mcc: '3043' },
      { description: 'Air Lanka', mcc: '3044' },
      { description: 'Nigeria Airways', mcc: '3045' },
      { description: 'Cruzerio do Sul (Brazil)', mcc: '3046' },
      { description: 'THY (Turkey)', mcc: '3047' },
      { description: 'Royal Air Maroc', mcc: '3048' },
      { description: 'Tunis Air', mcc: '3049' },
      { description: 'Icelandair', mcc: '3050' },
      { description: 'Austrian Airlines', mcc: '3051' },
      { description: 'Lan-Chile', mcc: '3052' },
      { description: 'AVIACO (Spain)', mcc: '3053' },
      { description: 'LADECO (Chile)', mcc: '3054' },
      { description: 'LAB (Bolivia)', mcc: '3055' },
      { description: 'Quebecaire', mcc: '3056' },
      { description: 'East-West Airlines (Australia)', mcc: '3057' },
      { description: 'Delta', mcc: '3058' },
      { description: 'DBA Airlines', mcc: '3059' },
      { description: 'Northwest Airlines', mcc: '3060' },
      { description: 'Continental', mcc: '3061' },
      { description: 'Western', mcc: '3062' },
      { description: 'U.S. Air', mcc: '3063' },
      { description: 'Adria Airways', mcc: '3064' },
      { description: 'Air Inter', mcc: '3065' },
      { description: 'Southwest Airlines', mcc: '3066' },
      { description: 'Vanguard Airlines', mcc: '3067' },
      { description: 'Air Astana', mcc: '3068' },
      { description: 'Sun Country Airlines', mcc: '3069' },
      { description: 'Air British Columbia', mcc: '3071' },
      { description: 'Cebu Pacific Airlines', mcc: '3072' },
      { description: 'Singapore Airlines', mcc: '3075' },
      { description: 'Aeromexico', mcc: '3076' },
      { description: 'Thai Airways', mcc: '3077' },
      { description: 'China Airlines', mcc: '3078' },
      { description: 'Jetstar Airways', mcc: '3079' },
      { description: 'Nordair', mcc: '3081' },
      { description: 'Korean Airlines', mcc: '3082' },
      { description: 'Air Afrique', mcc: '3083' },
      { description: 'Eva Airways', mcc: '3084' },
      { description: 'Midwest Express Airlines', mcc: '3085' },
      { description: 'Carnival Airlines', mcc: '3086' },
      { description: 'Metro Airlines', mcc: '3087' },
      { description: 'Croatia Air', mcc: '3088' },
      { description: 'Transaero', mcc: '3089' },
      { description: 'Uni Airways', mcc: '3090' },
      { description: 'Midway Airlines', mcc: '3092' },
      { description: 'Zambia Airways', mcc: '3094' },
      { description: 'Air Zimbabwe', mcc: '3096' },
      { description: 'Spanair', mcc: '3097' },
      { description: 'Asiana Airlines', mcc: '3098' },
      { description: 'Cathay Pacific', mcc: '3099' },
      { description: 'Malaysian Airline System', mcc: '3100' },
      { description: 'Iberia', mcc: '3102' },
      { description: 'Garuda (Indonesia)', mcc: '3103' },
      { description: 'Braathens S.A.F.E. (Norway)', mcc: '3106' },
      { description: 'Wings Airways', mcc: '3110' },
      { description: 'British Midland', mcc: '3111' },
      { description: 'Windward Island', mcc: '3112' },
      { description: 'Tower Air', mcc: '3115' },
      { description: 'Venezolana International de Aviacion', mcc: '3117' },
      { description: 'Valley Airlines', mcc: '3118' },
      { description: 'Tan Airlines', mcc: '3125' },
      { description: 'Talair', mcc: '3126' },
      { description: 'Taca International', mcc: '3127' },
      { description: 'Surinam Airways', mcc: '3129' },
      { description: 'Sunworld International Airways', mcc: '3130' },
      { description: 'VLM Airlines', mcc: '3131' },
      { description: 'Frontier Airlines', mcc: '3132' },
      { description: 'Sunbelt Airlines', mcc: '3133' },
      { description: 'Sudan Airways', mcc: '3135' },
      { description: 'Qatar Airways Company W.L.L.', mcc: '3136' },
      { description: 'Singleton Air', mcc: '3137' },
      { description: 'Simmons Airlines', mcc: '3138' },
      { description: 'Scenic Airlines', mcc: '3143' },
      { description: 'Virgin Atlantic', mcc: '3144' },
      { description: 'San Juan Airlines', mcc: '3145' },
      { description: 'Luxair', mcc: '3146' },
      { description: 'Air Littoral SA', mcc: '3148' },
      { description: 'Air Zaire', mcc: '3151' },
      { description: 'Princeville', mcc: '3154' },
      { description: 'Go Fly Ltd', mcc: '3156' },
      { description: 'Provincetown-Boston Airways', mcc: '3159' },
      { description: 'All Nippon Airways', mcc: '3161' },
      { description: 'Norontair', mcc: '3164' },
      { description: 'New York Helicopter', mcc: '3165' },
      { description: 'Aerocontinente', mcc: '3167' },
      { description: 'Mount Cook', mcc: '3170' },
      { description: 'Canadian Airlines', mcc: '3171' },
      { description: 'Nation Air', mcc: '3172' },
      { description: 'Middle East Air', mcc: '3175' },
      { description: 'Metroflight Airlines', mcc: '3176' },
      { description: 'Airtran Airways', mcc: '3177' },
      { description: 'Mesa Air', mcc: '3178' },
      { description: 'Westjet Airlines', mcc: '3180' },
      { description: 'Malev Hungarian Airlines', mcc: '3181' },
      { description: 'LOT', mcc: '3182' },
      { description: 'OMAN Aviation Services', mcc: '3183' },
      { description: 'LIAT', mcc: '3184' },
      { description: 'LAV Linea Aeropostal Venezolana', mcc: '3185' },
      { description: 'LAP Lineas Aereas Paraguayas', mcc: '3186' },
      { description: 'LACSA (Costa Rica)', mcc: '3187' },
      { description: 'Virgin Express', mcc: '3188' },
      { description: 'Jugoslav Air', mcc: '3190' },
      { description: 'Island Airlines', mcc: '3191' },
      { description: 'Iran Air', mcc: '3192' },
      { description: 'Indian Airlines', mcc: '3193' },
      { description: 'Hawaiian Air', mcc: '3196' },
      { description: 'Havasu Airlines', mcc: '3197' },
      { description: 'Harbor Airlines', mcc: '3198' },
      { description: 'Servicios Aereos Militares', mcc: '3199' },
      { description: 'Guyana Airways', mcc: '3200' },
      { description: 'Golden Pacific Air', mcc: '3203' },
      { description: 'Freedom Airlines', mcc: '3204' },
      { description: 'China Eastern Airlines', mcc: '3206' },
      { description: 'Empresa Ecuatoriana', mcc: '3207' },
      { description: 'Norwegian Air Shuttle', mcc: '3211' },
      { description: 'Dominicana de Aviacion', mcc: '3212' },
      { description: 'Malmo Aviation', mcc: '3213' },
      { description: 'Dan Air Services', mcc: '3215' },
      { description: 'Cumberland Airlines', mcc: '3216' },
      { description: 'CSA Ceskoslovenske Aerolinie', mcc: '3217' },
      { description: 'Crown Air', mcc: '3218' },
      { description: 'Compania Panamena de Aviacion (Copa)', mcc: '3219' },
      { description: 'Compania Faucett', mcc: '3220' },
      { description: 'Transportes Aeros Militares Ecuatorianos', mcc: '3221' },
      { description: 'Command Airways', mcc: '3222' },
      { description: 'Comair', mcc: '3223' },
      { description: 'Skyways', mcc: '3226' },
      { description: 'Cayman Airways', mcc: '3228' },
      { description: 'SAETA (Sociedad Ecuatorianas De Transportes Aereo)', mcc: '3229' },
      { description: 'SAHSA (Servicio Aero de Honduras)', mcc: '3231' },
      { description: 'Capitol Air', mcc: '3233' },
      { description: 'BWIA International', mcc: '3234' },
      { description: 'Brockway Air', mcc: '3235' },
      { description: 'Air Arabia Airline', mcc: '3236' },
      { description: 'Bemidji Airlines', mcc: '3238' },
      { description: 'Bar Harbor Airlines', mcc: '3239' },
      { description: 'Bahamasair', mcc: '3240' },
      { description: 'Aviateca (Guatemala)', mcc: '3241' },
      { description: 'Avensa', mcc: '3242' },
      { description: 'Austrian Air Service', mcc: '3243' },
      { description: 'Easyjet Air', mcc: '3245' },
      { description: 'Ryanair', mcc: '3246' },
      { description: 'Gol Airlines', mcc: '3247' },
      { description: 'Tam Airlines', mcc: '3248' },
      { description: 'Aloha Airlines', mcc: '3251' },
      { description: 'ALM Antilean Airlines', mcc: '3252' },
      { description: 'America West', mcc: '3253' },
      { description: 'US Air Shuttle', mcc: '3254' },
      { description: 'Alaska Airlines Inc.', mcc: '3256' },
      { description: 'American Trans Air', mcc: '3259' },
      { description: 'Spirit Airlines', mcc: '3260' },
      { description: 'Air China', mcc: '3261' },
      { description: 'Reno Air, Inc.', mcc: '3262' },
      { description: 'Aero Servicio Carabobo', mcc: '3263' },
      { description: 'Air Seychelles', mcc: '3266' },
      { description: 'Air Panama International', mcc: '3267' },
      { description: 'Air Pacific', mcc: '3268' },
      { description: 'Rica Hotels TSYS', mcc: '3273' },
      { description: 'Inter Nor Hotels TSYS', mcc: '3274' },
      { description: 'Air Nevada', mcc: '3275' },
      { description: 'Air Midwest', mcc: '3276' },
      { description: 'Air Madagascar', mcc: '3277' },
      { description: 'Air LA', mcc: '3279' },
      { description: 'Air Jamaica', mcc: '3280' },
      { description: 'Air Djibouti TSYS', mcc: '3281' },
      { description: 'Air Djibouti', mcc: '3282' },
      { description: 'Aero Virgin Islands', mcc: '3284' },
      { description: 'Aero Peru', mcc: '3285' },
      { description: 'Aero. Nicaraguenses', mcc: '3286' },
      { description: 'Aero Coach Aviation', mcc: '3287' },
      { description: 'Ariana Afghan', mcc: '3291' },
      { description: 'Cyprus Airways', mcc: '3292' },
      { description: 'Ecuatoriana', mcc: '3293' },
      { description: 'Ethiopian Airlines', mcc: '3294' },
      { description: 'Kenya Airways', mcc: '3295' },
      { description: 'Air Berlin', mcc: '3296' },
      { description: 'Tarom Romanian Air Transport', mcc: '3297' },
      { description: 'Air Mauritius', mcc: '3298' },
      { description: 'Wideroes Flyveselskap', mcc: '3299' },
      { description: 'Azul Brazilian Airlines', mcc: '3300' },
      { description: 'Wizz Air', mcc: '3301' },
      { description: 'Air Carriers, Airlines', mcc: '4511' },
    ],
  },
  {
    broadCategory: 'Amusement and Entertainment',
    categories: [
      { description: 'Motion Picture Theaters', mcc: '7832' },
      { description: 'Video Tape Rental Stores', mcc: '7841' },
      { description: 'Dance Halls, Schools, and Studios', mcc: '7911' },
      {
        description: 'Theatrical Producers (except Motion Pictures), Ticket Agencies',
        mcc: '7922',
      },
      { description: 'Bands, Orchestras, and Miscellaneous Entertainers', mcc: '7929' },
      { description: 'Billiard and Pool Establishments', mcc: '7932' },
      { description: 'Bowling Alleys', mcc: '7933' },
      {
        description:
          'Athletic Fields, Commercial Sports, Professional Sports Clubs, Sports Promoters',
        mcc: '7941',
      },
      { description: 'Tourist Attractions and Exhibits', mcc: '7991' },
      { description: 'Golf Courses, Public', mcc: '7992' },
      { description: 'Video Amusement Game Supplies', mcc: '7993' },
      { description: 'Video Game Arcades/Establishments', mcc: '7994' },
      {
        description:
          'Betting (including Lottery Tickets, Chips at Gaming Casinos, Off-Track Betting and Wagers at Race Tracks)',
        mcc: '7995',
      },
      { description: 'Amusement Parks, Carnivals, Circuses, Fortune Tellers', mcc: '7996' },
      { description: 'Clubs', mcc: '7997' },
      { description: 'Aquariums, Dolphinariums, and Seaquariums', mcc: '7998' },
      { description: 'Recreation Services', mcc: '7999' },
    ],
  },
  {
    broadCategory: 'Automobiles and Vehicles',
    categories: [
      { description: 'Automobile and Truck Dealers', mcc: '5511' },
      { description: 'Automobile and Truck Dealers', mcc: '5521' },
      { description: 'Auto Store, Home Supply Stores', mcc: '5531' },
      { description: 'Automotive Tire Stores', mcc: '5532' },
      { description: 'Automotive Parts, Accessories Stores', mcc: '5533' },
      { description: 'Service Stations (with or without Ancillary Services)', mcc: '5541' },
      { description: 'Fuel Dispenser, Automated', mcc: '5542' },
      { description: 'Boat Dealers', mcc: '5551' },
      { description: 'Camper Dealers, Recreational and Utility Trailers', mcc: '5561' },
      { description: 'Motorcycle Shops and Dealers', mcc: '5571' },
      { description: 'Motor Home Dealers', mcc: '5592' },
      { description: 'Snowmobile Dealers', mcc: '5598' },
      {
        description: 'Miscellaneous Automotive, Aircraft, and Farm Equipment Dealers',
        mcc: '5599',
      },
    ],
  },
  {
    broadCategory: 'Automotive/Vehicle Rentals',
    categories: [
      { description: 'Affiliated Auto Rental', mcc: '3351' },
      { description: 'American International', mcc: '3352' },
      { description: 'Brooks Rent A Car', mcc: '3353' },
      { description: 'Action Auto Rental', mcc: '3354' },
      { description: 'Sixt Car Rental', mcc: '3355' },
      { description: 'Hertz', mcc: '3357' },
      { description: 'Payless Car Rental', mcc: '3359' },
      { description: 'Snappy Car Rental', mcc: '3360' },
      { description: 'Airways Rent-A-Car', mcc: '3361' },
      { description: 'Altra Auto Rental', mcc: '3362' },
      { description: 'Agency Rent-A-Car', mcc: '3364' },
      { description: 'Budget Rent-A-Car', mcc: '3366' },
      { description: 'Holiday Rent-A-Car', mcc: '3368' },
      { description: 'Rent A Wreck', mcc: '3370' },
      { description: 'Accent Rent-A-Car', mcc: '3374' },
      { description: 'Ajax Rent-A-Car', mcc: '3376' },
      { description: 'Triangle Rent A Car', mcc: '3380' },
      { description: 'Europ Car', mcc: '3381' },
      { description: 'Tropical Rent-A-Car', mcc: '3385' },
      { description: 'Showcase Rental Cars', mcc: '3386' },
      { description: 'Alamo Rent-A-Car', mcc: '3387' },
      { description: 'Merchants Rent-A-Car', mcc: '3388' },
      { description: 'Avis Rent A Car', mcc: '3389' },
      { description: 'Dollar Rent A Car', mcc: '3390' },
      { description: 'Europe By Car', mcc: '3391' },
      { description: 'National Car Rental', mcc: '3393' },
      { description: 'Kemwell Group Rent-A-Car', mcc: '3394' },
      { description: 'Thrifty Car Rental', mcc: '3395' },
      { description: 'Tilden Rent-A-Car', mcc: '3396' },
      { description: 'Econo Car Rent-A-Car', mcc: '3398' },
      { description: 'Auto Host Car Rental', mcc: '3400' },
      { description: 'Enterprise Rent-A-Car', mcc: '3405' },
      { description: 'General Rent-A-Car', mcc: '3409' },
      { description: 'A1 Rent-A-Car', mcc: '3412' },
      { description: 'Godfrey National Rent-A-Car', mcc: '3414' },
      { description: 'Alpha Rent-A-Car', mcc: '3419' },
      { description: 'ANSA International', mcc: '3420' },
      { description: 'Allstate Rent-A-Car', mcc: '3421' },
      { description: 'Avcar Rent-A-Car', mcc: '3423' },
      { description: 'Automate Rent-A-Car', mcc: '3425' },
      { description: 'Avon Rent-A-Car', mcc: '3427' },
      { description: 'Carey Rent-A-Car', mcc: '3428' },
      { description: 'Insurance Rent-A-Car', mcc: '3429' },
      { description: 'Major Rent-A-Car', mcc: '3430' },
      { description: 'Replacement Rent-A-Car', mcc: '3431' },
      { description: 'Reserve Rent-A-Car', mcc: '3432' },
      { description: 'Ugly Duckling Rent-A-Car', mcc: '3433' },
      { description: 'USA Rent-A-Car', mcc: '3434' },
      { description: 'Value Rent-A-Car', mcc: '3435' },
      { description: 'Autohansa Rent-A-Car', mcc: '3436' },
      { description: 'Cite Rent-A-Car', mcc: '3437' },
      { description: 'Interent Rent-A-Car', mcc: '3438' },
      { description: 'Milleville Rent-A-Car', mcc: '3439' },
      { description: 'Via Route Rent-A-Car', mcc: '3440' },
      { description: 'Advantage Rent A Car', mcc: '3441' },
      { description: 'Automobile Rental Agency', mcc: '7512' },
      { description: 'Truck and Utility Trailer Rental', mcc: '7513' },
      { description: 'Motor Home and Recreational Vehicle Rental', mcc: '7519' },
    ],
  },
  {
    broadCategory: 'Business Services',
    categories: [
      { description: 'Advertising Services', mcc: '7311' },
      { description: 'Consumer Credit Reporting Agencies', mcc: '7321' },
      { description: 'Commercial Art, Graphics, Photography', mcc: '7333' },
      { description: 'Quick Copy, Reproduction, and Blueprinting Services', mcc: '7338' },
      { description: 'Stenographic and Secretarial Support Services', mcc: '7339' },
      { description: 'Exterminating and Disinfecting Services', mcc: '7342' },
      { description: 'Cleaning and Maintenance, Janitorial Services', mcc: '7349' },
      { description: 'Employment Agencies, Temporary Help Services', mcc: '7361' },
      {
        description:
          'Computer Programming, Data Processing, and Integrated Systems Design Services',
        mcc: '7372',
      },
      { description: 'Consulting, Management, and Public Relations Services', mcc: '7392' },
      {
        description:
          'Detective Agencies, Protective Agencies, Security Services including Armored Cars, Guard Dogs',
        mcc: '7393',
      },
      {
        description: 'Equipment Rental and Leasing Services, Furniture Rental, Tool Rental',
        mcc: '7394',
      },
      { description: 'Photo Developing, Photofinishing Laboratories', mcc: '7395' },
      { description: 'Business Services', mcc: '7399' },
      { description: 'Automobile Parking Lots and Garages', mcc: '7523' },
    ],
  },
  {
    broadCategory: 'Clothing Stores',
    categories: [
      { description: "Men's and Boy's Clothing and Furnishings Store", mcc: '5611' },
      { description: "Women's Ready to Wear Stores", mcc: '5621' },
      { description: "Women's Accessory and Speciality Stores", mcc: '5631' },
      { description: "Children's and Infants' Wear Stores", mcc: '5641' },
      { description: 'Family Clothing Stores', mcc: '5651' },
      { description: 'Sports Apparel, Riding Apparel Stores', mcc: '5655' },
      { description: 'Shoe Stores', mcc: '5661' },
      { description: 'Furriers and Fur Shops', mcc: '5681' },
      { description: "Men's and Women's Clothing Stores", mcc: '5691' },
      { description: 'Alterations, Mending, Seamstresses, Tailors', mcc: '5697' },
      { description: 'Wig and Toupee Shops', mcc: '5698' },
      { description: 'Accessory and Apparel Stores', mcc: '5699' },
    ],
  },
  {
    broadCategory: 'Contracted Services',
    categories: [
      { description: 'Veterinary Services', mcc: '0742' },
      { description: 'Agricultural Cooperatives', mcc: '0763' },
      { description: 'Horticultural and Landscaping Services', mcc: '0780' },
      { description: 'General Contractors', mcc: '1520' },
      { description: 'Air Conditioning, Heating, and Plumbing Contractors', mcc: '1711' },
      { description: 'Electrical Contractors', mcc: '1731' },
      {
        description: 'Insulation, Masonry, Plastering, Stonework, and Tile Setting Contractors',
        mcc: '1740',
      },
      { description: 'Carpentry Contractors', mcc: '1750' },
      { description: 'Roofing and Siding, Sheet Metal Work Contractors', mcc: '1761' },
      { description: 'Concrete Work Contractors', mcc: '1771' },
      { description: 'Contractors, Special Trade', mcc: '1799' },
    ],
  },
  {
    broadCategory: 'Government Services',
    categories: [
      { description: 'Court Costs including Alimony and Child Support', mcc: '9211' },
      { description: 'Fines', mcc: '9222' },
      { description: 'Bail and Bond Payments', mcc: '9223' },
      { description: 'Tax Payments', mcc: '9311' },
      { description: 'Government Services', mcc: '9399' },
      { description: 'Postal Services', mcc: '9402' },
    ],
  },
  {
    broadCategory: 'Hotels and Motels',
    categories: [
      { description: 'Holiday Inns', mcc: '3501' },
      { description: 'Best Western Hotels', mcc: '3502' },
      { description: 'Sheraton Hotels', mcc: '3503' },
      { description: 'Hilton Hotels', mcc: '3504' },
      { description: 'Forte Hotels', mcc: '3505' },
      { description: 'Golden Tulip Hotels', mcc: '3506' },
      { description: 'Friendship Inns', mcc: '3507' },
      { description: 'Quality Inns', mcc: '3508' },
      { description: 'Marriott Hotels', mcc: '3509' },
      { description: 'Days Inns', mcc: '3510' },
      { description: 'Arabella Hotels', mcc: '3511' },
      { description: 'Intercontinental Hotels', mcc: '3512' },
      { description: 'Westin Hotels', mcc: '3513' },
      { description: 'Amerisuites', mcc: '3514' },
      { description: 'Rodeway Inns', mcc: '3515' },
      { description: 'La Quinta Motor Inns', mcc: '3516' },
      { description: 'Americana Hotels', mcc: '3517' },
      { description: 'Sol Hotels', mcc: '3518' },
      { description: 'Pullman International Hotels', mcc: '3519' },
      { description: 'Meridien Hotels', mcc: '3520' },
      { description: 'Crest Hotels', mcc: '3521' },
      { description: 'Tokyo Hotel', mcc: '3522' },
      { description: 'Peninsula Hotels', mcc: '3523' },
      { description: 'WelcomGroup Hotels', mcc: '3524' },
      { description: 'Dunfey Hotels', mcc: '3525' },
      { description: 'Prince Hotels', mcc: '3526' },
      { description: 'Downtowner Passport', mcc: '3527' },
      { description: 'Red Lion Inns', mcc: '3528' },
      { description: 'CP (Canadian Pacific) Hotels', mcc: '3529' },
      { description: 'Renaissance Hotels', mcc: '3530' },
      { description: 'Astir Hotels / Kauai Coconut Beach Resort', mcc: '3531' },
      { description: 'Sun Route Hotels / Royal Kona Resort', mcc: '3532' },
      { description: 'Hotel Ibis', mcc: '3533' },
      { description: 'Southern Pacific Hotels', mcc: '3534' },
      { description: 'Hilton International', mcc: '3535' },
      { description: 'AMFAC Hotels', mcc: '3536' },
      { description: 'ANA Hotels', mcc: '3537' },
      { description: 'Concorde Hotels', mcc: '3538' },
      { description: 'Summerfield Suites Hotel', mcc: '3539' },
      { description: 'Iberotel Hotels', mcc: '3540' },
      { description: 'Hotel Okura', mcc: '3541' },
      { description: 'Royal Hotels', mcc: '3542' },
      { description: 'Four Seasons Hotels', mcc: '3543' },
      { description: 'Ciga Hotels', mcc: '3544' },
      { description: 'Shangri-La International', mcc: '3545' },
      { description: 'Sierra Suites Hotel', mcc: '3546' },
      { description: 'Breakers Resort M', mcc: '3547' },
      { description: 'Hotels Melia', mcc: '3548' },
      { description: 'Auberge des Governeures', mcc: '3549' },
      { description: 'Regal 8 Inns', mcc: '3550' },
      { description: 'Mirage Hotel and Casino', mcc: '3551' },
      { description: 'Coast Hotel', mcc: '3552' },
      { description: 'Park Inns International', mcc: '3553' },
      { description: 'Pinehurst Resort', mcc: '3554' },
      { description: 'Treasure Island Hotel and Casino', mcc: '3555' },
      { description: 'Barton Creek Resort', mcc: '3556' },
      { description: 'Manhattan East Suite Hotels', mcc: '3557' },
      { description: 'Jolly Hotels', mcc: '3558' },
      { description: 'Candlewood Suites', mcc: '3559' },
      { description: 'Aladdin Resort and Casino', mcc: '3560' },
      { description: 'Golden Nugget', mcc: '3561' },
      { description: 'Comfort Inns', mcc: '3562' },
      { description: "Journey's End Motels", mcc: '3563' },
      { description: 'Sams Town Hotel and Casino', mcc: '3564' },
      { description: 'Relax Inns', mcc: '3565' },
      { description: 'Garden Place Hotel', mcc: '3566' },
      { description: 'Soho Grand Hotel', mcc: '3567' },
      { description: 'Ladbroke Hotels', mcc: '3568' },
      { description: 'Tribeca Grand Hotel', mcc: '3569' },
      { description: 'Forum Hotels', mcc: '3570' },
      { description: 'Grand Wailea Resort', mcc: '3571' },
      { description: 'Miyako Hotel', mcc: '3572' },
      { description: 'Sandman Hotels', mcc: '3573' },
      { description: 'Venture Inn', mcc: '3574' },
      { description: 'Vagabond Hotels', mcc: '3575' },
      { description: 'La Quinta Resort', mcc: '3576' },
      { description: 'Mandarin Oriental Hotels', mcc: '3577' },
      { description: 'Frankenmuth Bavarian', mcc: '3578' },
      { description: 'Hotel Mercure', mcc: '3579' },
      { description: 'Hotel Del Coronado', mcc: '3580' },
      { description: 'Delta Hotels', mcc: '3581' },
      { description: 'California Hotel and Casino', mcc: '3582' },
      { description: 'SAS Hotels', mcc: '3583' },
      { description: 'Princess Hotels International', mcc: '3584' },
      { description: 'Hungar Hotels', mcc: '3585' },
      { description: 'Sokos Hotel', mcc: '3586' },
      { description: 'Doral Hotels', mcc: '3587' },
      { description: 'Helmsley Hotels', mcc: '3588' },
      { description: 'Doral Golf Resort', mcc: '3589' },
      { description: 'Fairmont Hotels', mcc: '3590' },
      { description: 'Sonesta Hotels', mcc: '3591' },
      { description: 'Omni Hotels', mcc: '3592' },
      { description: 'Cunard Hotels', mcc: '3593' },
      { description: 'Arizona Biltmore', mcc: '3594' },
      { description: 'Hospitality Inns', mcc: '3595' },
      { description: 'Wynn Las Vegas', mcc: '3596' },
      { description: 'Riverside Resort and Casino', mcc: '3597' },
      { description: 'Regent International Hotel', mcc: '3598' },
      { description: 'Pannonia Hotels', mcc: '3599' },
      { description: 'Saddlebrook Resort–Tampa', mcc: '3600' },
      { description: 'Tradewinds Resort', mcc: '3601' },
      { description: 'Hudson Hotel', mcc: '3602' },
      { description: "Noah's Hotel", mcc: '3603' },
      { description: 'Hilton Garden Inn', mcc: '3604' },
      { description: 'Jurys Doyle Hotel Group M', mcc: '3605' },
      { description: 'Jefferson Hotel M', mcc: '3606' },
      { description: 'Fontainebleau Resort', mcc: '3607' },
      { description: 'Gaylord Opryland', mcc: '3608' },
      { description: 'Gaylord Palms', mcc: '3609' },
      { description: 'Gaylord Texan M', mcc: '3610' },
      { description: 'C MON INN M', mcc: '3611' },
      { description: 'Movenpick Hotels', mcc: '3612' },
      { description: 'Microtel Inn and Suites', mcc: '3613' },
      { description: 'AmericInn', mcc: '3614' },
      { description: 'Travelodge', mcc: '3615' },
      { description: 'Hermitage Hotels M', mcc: '3616' },
      { description: "America's Best Value Inn", mcc: '3617' },
      { description: 'Great Wolf', mcc: '3618' },
      { description: 'Aloft', mcc: '3619' },
      { description: 'Binions Horseshoe Club', mcc: '3620' },
      { description: 'Extended Stay', mcc: '3621' },
      { description: 'Merlin Hotel Group', mcc: '3622' },
      { description: 'Dorint Hotels', mcc: '3623' },
      { description: 'Lady Luck Hotel and Casino', mcc: '3624' },
      { description: 'Hotel Universale', mcc: '3625' },
      { description: 'Studio Plus', mcc: '3626' },
      { description: 'Extended Stay America', mcc: '3627' },
      { description: 'Excalibur Hotel and Casino', mcc: '3628' },
      { description: 'Dan Hotels', mcc: '3629' },
      { description: 'Extended Stay Deluxe', mcc: '3630' },
      { description: 'Sleep Inns', mcc: '3631' },
      { description: 'The Phoenician', mcc: '3632' },
      { description: 'Rank Hotels', mcc: '3633' },
      { description: 'Swissotel', mcc: '3634' },
      { description: 'Reso Hotel', mcc: '3635' },
      { description: 'Sarova Hotels', mcc: '3636' },
      { description: 'Ramada Inns', mcc: '3637' },
      { description: 'Howard Johnson', mcc: '3638' },
      { description: 'Mount Charlotte Thistle', mcc: '3639' },
      { description: 'Hyatt Hotels', mcc: '3640' },
      { description: 'Sofitel Hotels', mcc: '3641' },
      { description: 'Novotel Hotels', mcc: '3642' },
      { description: 'Steigenberger Hotels', mcc: '3643' },
      { description: 'EconoLodges', mcc: '3644' },
      { description: 'Queens Moat Houses', mcc: '3645' },
      { description: 'Swallow Hotels', mcc: '3646' },
      { description: 'Husa Hotels', mcc: '3647' },
      { description: 'De Vera Hotels', mcc: '3648' },
      { description: 'Radisson Hotels', mcc: '3649' },
      { description: 'Red Roof Inns', mcc: '3650' },
      { description: 'Imperial London Hotels', mcc: '3651' },
      { description: 'Embassy Hotels', mcc: '3652' },
      { description: 'Penta Hotels', mcc: '3653' },
      { description: 'Loews Hotels', mcc: '3654' },
      { description: 'Scandic Hotels', mcc: '3655' },
      { description: 'Sara Hotels', mcc: '3656' },
      { description: 'Oberoi Hotels', mcc: '3657' },
      { description: 'Otani Hotels', mcc: '3658' },
      { description: 'Taj Hotels International', mcc: '3659' },
      { description: 'Knights Inn', mcc: '3660' },
      { description: 'Metropole Hotels', mcc: '3661' },
      { description: 'Circus Circus Hotel and Casino', mcc: '3662' },
      { description: 'Hoteles El Presidente', mcc: '3663' },
      { description: 'Flag Inns', mcc: '3664' },
      { description: 'Hampton Inn Hotels', mcc: '3665' },
      { description: 'Stakis Hotels', mcc: '3666' },
      { description: 'Luxor Hotel and Casino', mcc: '3667' },
      { description: 'Maritim Hotels', mcc: '3668' },
      { description: 'Eldorado Hotel and Casino', mcc: '3669' },
      { description: 'Arcade Hotels', mcc: '3670' },
      { description: 'Arctia Hotels', mcc: '3671' },
      { description: 'Campanile Hotels', mcc: '3672' },
      { description: 'IBUSZ Hotels', mcc: '3673' },
      { description: 'Rantasipi Hotels', mcc: '3674' },
      { description: 'Interhotel CEDOK', mcc: '3675' },
      { description: 'Monte Carlo Hotel and Casino', mcc: '3676' },
      { description: 'Climat de France Hotels', mcc: '3677' },
      { description: 'Cumulus Hotels', mcc: '3678' },
      { description: 'Silver Legacy Hotel and Casino', mcc: '3679' },
      { description: 'Hoteis Othan', mcc: '3680' },
      { description: 'Adams Mark Hotels', mcc: '3681' },
      { description: 'Sahara Hotel and Casino', mcc: '3682' },
      { description: 'Bradbury Suites', mcc: '3683' },
      { description: 'Budget Hosts Inns', mcc: '3684' },
      { description: 'Budgetel Inns', mcc: '3685' },
      { description: 'Susse Chalet', mcc: '3686' },
      { description: 'Clarion Hotels', mcc: '3687' },
      { description: 'Compri Hotels', mcc: '3688' },
      { description: 'Consort Hotels', mcc: '3689' },
      { description: 'Courtyard Inns', mcc: '3690' },
      { description: 'Dillon Inn', mcc: '3691' },
      { description: 'Doubletree Hotels', mcc: '3692' },
      { description: 'Drury Inn', mcc: '3693' },
      { description: 'Economy Inns of America', mcc: '3694' },
      { description: 'Embassy Suites', mcc: '3695' },
      { description: 'Excel Inn', mcc: '3696' },
      { description: 'Fairfield Hotels', mcc: '3697' },
      { description: 'Harley Hotels', mcc: '3698' },
      { description: 'Midway Motor Lodge', mcc: '3699' },
      { description: 'Motel 6', mcc: '3700' },
      { description: 'La Mansion Del Rio', mcc: '3701' },
      { description: 'Registry Hotels, The', mcc: '3702' },
      { description: 'Residence Inn', mcc: '3703' },
      { description: 'Royce Hotels', mcc: '3704' },
      { description: 'Sandman Inn', mcc: '3705' },
      { description: 'Shilo Inn', mcc: '3706' },
      { description: "Shoney's Inn", mcc: '3707' },
      { description: 'Virgin River Hotel and Casino', mcc: '3708' },
      { description: 'Super 8 Motels', mcc: '3709' },
      { description: 'Ritz Carlton, The', mcc: '3710' },
      { description: 'Flag Inns (Australia)', mcc: '3711' },
      { description: 'Buffalo Bills Hotel and Casino', mcc: '3712' },
      { description: 'Quality Pacific Hotel', mcc: '3713' },
      { description: 'Four Seasons (Australia) Hotels', mcc: '3714' },
      { description: 'Fairfield Inn', mcc: '3715' },
      { description: 'Carlton Hotels', mcc: '3716' },
      { description: 'City Lodge Hotels', mcc: '3717' },
      { description: 'Karos Hotels', mcc: '3718' },
      { description: 'Protea Hotels', mcc: '3719' },
      { description: 'Southern Sun Hotels', mcc: '3720' },
      { description: 'Conrad Hotels', mcc: '3721' },
      { description: 'Wyndham Hotels', mcc: '3722' },
      { description: 'Rica Hotels', mcc: '3723' },
      { description: 'Inter Nor Hotels', mcc: '3724' },
      { description: 'Seapines Plantation', mcc: '3725' },
      { description: 'Rio Suites', mcc: '3726' },
      { description: 'Broadmoor Hotel', mcc: '3727' },
      { description: 'Ballys Hotel and Casino', mcc: '3728' },
      { description: 'John Ascuagas Nugget', mcc: '3729' },
      { description: 'MGM Grand Hotel', mcc: '3730' },
      { description: 'Harrahs Hotels and Casinos', mcc: '3731' },
      { description: 'Opryland Hotel', mcc: '3732' },
      { description: 'Boca Raton Resort', mcc: '3733' },
      { description: 'Harvey Bristol Hotels', mcc: '3734' },
      { description: 'Masters Economy Inns', mcc: '3735' },
      { description: 'Colorado Belle Edgewater Resort', mcc: '3736' },
      { description: 'Riviera Hotel and Casino', mcc: '3737' },
      { description: 'Tropicana Resort and Casino', mcc: '3738' },
      { description: 'Woodside Hotels and Resorts', mcc: '3739' },
      { description: 'TownePlace Suites', mcc: '3740' },
      { description: 'Millennium Broadway Hotel', mcc: '3741' },
      { description: 'Club Med', mcc: '3742' },
      { description: 'Biltmore Hotel and Suites', mcc: '3743' },
      { description: 'Carefree Resorts', mcc: '3744' },
      { description: 'St. Regis Hotel', mcc: '3745' },
      { description: 'Eliot Hotels', mcc: '3746' },
      { description: 'Club Corp/Club Resorts', mcc: '3747' },
      { description: 'Wellesley Inns', mcc: '3748' },
      { description: 'The Beverly Hills Hotel', mcc: '3749' },
      { description: 'Crowne Plaza Hotels', mcc: '3750' },
      { description: 'Homewood Suites', mcc: '3751' },
      { description: 'Peabody Hotels', mcc: '3752' },
      { description: 'Greenbriar Resorts', mcc: '3753' },
      { description: 'Amelia Island Plantation', mcc: '3754' },
      { description: 'The Homestead', mcc: '3755' },
      { description: 'South Seas Resorts', mcc: '3756' },
      { description: 'Canyon Ranch', mcc: '3757' },
      { description: 'Kahala Mandarin Oriental Hotel', mcc: '3758' },
      { description: 'The Orchid at Mauna Lani', mcc: '3759' },
      { description: 'Halekulani Hotel/Waikiki Parc', mcc: '3760' },
      { description: 'Primadonna Hotel and Casino', mcc: '3761' },
      { description: 'Whiskey Petes Hotel and Casino', mcc: '3762' },
      { description: 'Chateau Elan Winery and Resort', mcc: '3763' },
      { description: 'Beau Rivage Hotel and Casino', mcc: '3764' },
      { description: 'Bellagio', mcc: '3765' },
      { description: 'Fremont Hotel and Casino', mcc: '3766' },
      { description: 'Main Street Hotel and Casino', mcc: '3767' },
      { description: 'Silver Star Hotel and Casino', mcc: '3768' },
      { description: 'Stratosphere Hotel and Casino', mcc: '3769' },
      { description: 'SpringHill Suites', mcc: '3770' },
      { description: 'Caesars Hotel and Casino', mcc: '3771' },
      { description: 'Nemacolin Woodlands', mcc: '3772' },
      { description: 'Venetian Resort Hotel and Casino', mcc: '3773' },
      { description: 'New York-New York Hotel and Casino', mcc: '3774' },
      { description: 'Ocean Dunes Resort and Villas', mcc: '3775' },
      { description: 'Nevele Grande Resort and Country Club', mcc: '3776' },
      { description: 'Mandalay Bay Resort', mcc: '3777' },
      { description: 'Four Points Hotels', mcc: '3778' },
      { description: 'W Hotels', mcc: '3779' },
      { description: 'Disneyland Resorts', mcc: '3780' },
      { description: 'Patricia Grand Resort Hotels', mcc: '3781' },
      { description: 'Rosen Hotel and Resorts', mcc: '3782' },
      { description: 'Town and Country Resort and Convention Center', mcc: '3783' },
      { description: 'First Hospitality Hotels', mcc: '3784' },
      { description: 'Outrigger Hotels and Resorts', mcc: '3785' },
      { description: 'Ohana Hotels of Hawaii', mcc: '3786' },
      { description: 'Caribe Royal Resort Suite and Villas', mcc: '3787' },
      { description: 'Ala Moana Hotel', mcc: '3788' },
      { description: 'Smugglers Notch Resort', mcc: '3789' },
      { description: 'Raffles Hotels', mcc: '3790' },
      { description: 'Staybridge Suites', mcc: '3791' },
      { description: 'Claridge Casino Hotel', mcc: '3792' },
      { description: 'The Flamingo Hotels', mcc: '3793' },
      { description: 'Grand Casino Hotels', mcc: '3794' },
      { description: 'Paris Las Vegas Hotel', mcc: '3795' },
      { description: 'Peppermill Hotel Casino', mcc: '3796' },
      { description: 'Atlantic City Hilton', mcc: '3797' },
      { description: 'Embassy Vacation Resort', mcc: '3798' },
      { description: 'Hale Koa Hotel', mcc: '3799' },
      { description: 'Homestead Suites', mcc: '3800' },
      { description: 'Wilderness Hotel and Resort', mcc: '3801' },
      { description: 'The Palace Hotel', mcc: '3802' },
      { description: 'The Wigwam Golf Resort and Spa', mcc: '3803' },
      { description: 'The Diplomat Country Club and Spa', mcc: '3804' },
      { description: 'The Atlantic', mcc: '3805' },
      { description: 'Princeville Resort', mcc: '3806' },
      { description: 'Element', mcc: '3807' },
      { description: 'LXR (Luxury Resorts)', mcc: '3808' },
      { description: 'Settle Inn', mcc: '3809' },
      { description: 'La Costa Resort', mcc: '3810' },
      { description: 'Premier Travel Inns', mcc: '3811' },
      { description: 'Hyatt Place', mcc: '3812' },
      { description: 'Hotel Indigo', mcc: '3813' },
      { description: 'The Roosevelt Hotel NY', mcc: '3814' },
      { description: 'Nickelodeon Family Suites by Holiday Inn', mcc: '3815' },
      { description: 'Home2Suites', mcc: '3816' },
      { description: 'Affinia M', mcc: '3817' },
      { description: 'Mainstay Suites', mcc: '3818' },
      { description: 'Oxford Suites', mcc: '3819' },
      { description: 'Jumeirah Essex House', mcc: '3820' },
      { description: 'Caribe Royal', mcc: '3821' },
      { description: 'Crossland', mcc: '3822' },
      { description: 'Grand Sierra Resort', mcc: '3823' },
      { description: 'Aria', mcc: '3824' },
      { description: 'Vdara', mcc: '3825' },
      { description: 'Autograph', mcc: '3826' },
      { description: 'Galt House', mcc: '3827' },
      { description: 'Cosmopolitan of Las Vegas', mcc: '3828' },
      { description: 'Country Inn By Carlson', mcc: '3829' },
      { description: 'Park Plaza Hotel', mcc: '3830' },
      { description: 'Waldorf', mcc: '3831' },
      { description: 'Curio Hotels', mcc: '3832' },
      { description: 'Canopy', mcc: '3833' },
      { description: 'Baymont Inn & Suites', mcc: '3834' },
      { description: 'Dolce Hotels and Resorts', mcc: '3835' },
      { description: 'Hawthorn by Wyndham', mcc: '3836' },
      { description: 'Lodging', mcc: '7011' },
    ],
  },
  {
    broadCategory: 'Mail Order/Telephone Order Providers',
    categories: [
      { description: 'Mail Order Houses Including Catalog Order Stores TSYS', mcc: '5961' },
      { description: 'Direct Marketing', mcc: '5962' },
      { description: 'Direct Marketing', mcc: '5964' },
      { description: 'Direct Marketing', mcc: '5965' },
      { description: 'Direct Marketing', mcc: '5966' },
      { description: 'Direct Marketing', mcc: '5967' },
      { description: 'Direct Marketing', mcc: '5968' },
      { description: 'Direct Marketing', mcc: '5969' },
    ],
  },
  {
    broadCategory: 'Miscellaneous Stores',
    categories: [
      {
        description: 'Equipment, Furniture, and Home Furnishings Stores (except Appliances)',
        mcc: '5712',
      },
      { description: 'Floor Covering Stores', mcc: '5713' },
      { description: 'Drapery, Upholstery, and Window Coverings Stores', mcc: '5714' },
      { description: 'Fireplace, Fireplace Screens and Accessories Stores', mcc: '5718' },
      { description: 'Household Appliance Stores', mcc: '5722' },
      { description: 'Electronic Sales', mcc: '5732' },
      { description: 'Music Stores', mcc: '5733' },
      { description: 'Computer Software Stores', mcc: '5734' },
      { description: 'Record Shops', mcc: '5735' },
      { description: 'Caterers', mcc: '5811' },
      { description: 'Eating Places, Restaurants', mcc: '5812' },
      { description: 'Bars, Cocktail Lounges, Discotheques, Nightclubs, and Taverns', mcc: '5813' },
      { description: 'Quick Payment Service', mcc: '5814' },
      { description: 'Drug Stores, Pharmacies', mcc: '5912' },
      { description: 'Package Stores, Beer, Wine, Liquor', mcc: '5921' },
      { description: 'Second Hand Stores, Used Merchandise Stores', mcc: '5931' },
      { description: 'Antique Shops', mcc: '5932' },
      { description: 'Pawn Shops', mcc: '5933' },
      { description: 'Antique Reproduction Stores', mcc: '5937' },
      { description: 'Bicycle Shops', mcc: '5940' },
      { description: 'Sporting Goods Stores', mcc: '5941' },
      { description: 'Book Stores', mcc: '5942' },
      { description: 'Office, School Supply, and Stationery Stores', mcc: '5943' },
      { description: 'Clock, Jewelry, Watch, and Silverware Store', mcc: '5944' },
      { description: 'Game, Toy, and Hobby Shops', mcc: '5945' },
      { description: 'Camera and Photographic Supply Stores', mcc: '5946' },
      { description: 'Card, Gift, Novelty, and Souvenir Shops', mcc: '5947' },
      { description: 'Leather Goods and Luggage Stores', mcc: '5948' },
      { description: 'Fabric, Needlework, Piece Goods, and Sewing Stores', mcc: '5949' },
      { description: 'Crystal and Glassware Stores', mcc: '5950' },
      { description: 'Artist Supply Stores, Craft Shops', mcc: '5970' },
      { description: 'Art Dealers and Galleries', mcc: '5971' },
      { description: 'Stamp and Coin Stores', mcc: '5972' },
      { description: 'Religious Goods Stores', mcc: '5973' },
      { description: 'Hearing Aids', mcc: '5975' },
      { description: 'Orthopedic Goods', mcc: '5976' },
      { description: 'Cosmetic Stores', mcc: '5977' },
      { description: 'Typewriter Stores', mcc: '5978' },
      { description: 'Fuel Dealers', mcc: '5983' },
      { description: 'Florists', mcc: '5992' },
      { description: 'Cigar Stores and Stands', mcc: '5993' },
      { description: 'News Dealers and Newsstands', mcc: '5994' },
      { description: 'Pet Shops', mcc: '5995' },
      { description: 'Swimming Pools', mcc: '5996' },
      { description: 'Electric Razor Stores', mcc: '5997' },
      { description: 'Tent and Awning Shops', mcc: '5998' },
    ],
  },
  {
    broadCategory: 'Personal Service Providers',
    categories: [
      { description: 'Cleaning, Garment, and Laundry Services', mcc: '7210' },
      { description: 'Laundry Services', mcc: '7211' },
      { description: 'Dry Cleaners', mcc: '7216' },
      { description: 'Carpet and Upholstery Cleaning', mcc: '7217' },
      { description: 'Photographic Studios', mcc: '7221' },
      { description: 'Barber and Beauty Shops', mcc: '7230' },
      { description: 'Hat Cleaning Shops, Shoe Repair Shops, Shoe Shine Parlors', mcc: '7251' },
      { description: 'Funeral Service and Crematories', mcc: '7261' },
      { description: 'Dating and Escort Services', mcc: '7273' },
      { description: 'Tax Preparation Service', mcc: '7276' },
      { description: 'Debt, Marriage, Personal', mcc: '7277' },
      { description: 'Buying/Shopping Clubs, Services', mcc: '7278' },
      { description: 'Clothing Rental', mcc: '7296' },
      { description: 'Massage Parlors', mcc: '7297' },
      { description: 'Health and Beauty Spas', mcc: '7298' },
      { description: 'Other Services', mcc: '7299' },
    ],
  },
  {
    broadCategory: 'Professional Services and Membership Org',
    categories: [
      { description: 'Doctors', mcc: '8011' },
      { description: 'Dentists, Orthodontists', mcc: '8021' },
      { description: 'Osteopathic Physicians', mcc: '8031' },
      { description: 'Chiropractors', mcc: '8041' },
      { description: 'Optometrists, Ophthalmologists', mcc: '8042' },
      { description: 'Opticians, Optical Goods, and Eyeglasses', mcc: '8043' },
      { description: 'Chiropodists, Podiatrists', mcc: '8049' },
      { description: 'Nursing and Personal Care Facilities', mcc: '8050' },
      { description: 'Hospitals', mcc: '8062' },
      { description: 'Dental and Medical Laboratories', mcc: '8071' },
      { description: 'Health Practitioners, Medical Services', mcc: '8099' },
      { description: 'Attorneys, Legal Services', mcc: '8111' },
      { description: 'Schools, Elementary and Secondary', mcc: '8211' },
      {
        description: 'Colleges, Universities, Professional Schools, and Junior Colleges',
        mcc: '8220',
      },
      { description: 'Schools, Correspondence', mcc: '8241' },
      { description: 'Schools, Business and Secretarial', mcc: '8244' },
      { description: 'Schools, Trade and Vocational', mcc: '8249' },
      { description: 'Schools and Educational Services', mcc: '8299' },
      { description: 'Child Care Services', mcc: '8351' },
      { description: 'Organizations, Charitable and Social Service', mcc: '8398' },
      { description: 'Associations', mcc: '8641' },
      { description: 'Organizations, Political', mcc: '8651' },
      { description: 'Organizations, Religious', mcc: '8661' },
      { description: 'Associations, Automobile', mcc: '8675' },
      { description: 'Organizations, Membership', mcc: '8699' },
      { description: 'Architectural, Engineering, and Surveying Services', mcc: '8911' },
      { description: 'Accounting, Auditing, and Bookkeeping Services', mcc: '8931' },
      { description: 'Professional Services', mcc: '8999' },
    ],
  },
  {
    broadCategory: 'Repair Services',
    categories: [
      { description: 'Automotive Body Repair Shops', mcc: '7531' },
      { description: 'Tire Retreading and Repair Shops', mcc: '7534' },
      { description: 'Automotive Paint Shops', mcc: '7535' },
      { description: 'Automotive Service Shops', mcc: '7538' },
      { description: 'Car Washes', mcc: '7542' },
      { description: 'Towing Services', mcc: '7549' },
      { description: 'Electronic Repair Shops', mcc: '7622' },
      { description: 'Air Conditioning and Refrigeration Repair Shops', mcc: '7623' },
      { description: 'Appliance Repair Shops, Electrical and Small', mcc: '7629' },
      { description: 'Clock, Jewelry, and Watch Repair Shops', mcc: '7631' },
      { description: 'Furniture', mcc: '7641' },
      { description: 'Welding Repair', mcc: '7692' },
    ],
  },
  {
    broadCategory: 'Retail Stores',
    categories: [
      { description: 'Home Supply Warehouse', mcc: '5200' },
      { description: 'Building Materials, Lumber Stores', mcc: '5211' },
      { description: 'Glass, Paint, Wallpaper Stores', mcc: '5231' },
      { description: 'Hardware Stores', mcc: '5251' },
      { description: 'Lawn and Garden Supply Stores', mcc: '5261' },
      { description: 'Mobile Home Dealers', mcc: '5271' },
      { description: 'Wholesale Clubs', mcc: '5300' },
      { description: 'Duty Free Stores', mcc: '5309' },
      { description: 'Discount Stores', mcc: '5310' },
      { description: 'Department Stores', mcc: '5311' },
      { description: 'Grocery Stores, Supermarkets', mcc: '5411' },
      { description: 'Candy, Nut, Confectionery Stores', mcc: '5441' },
      { description: 'Dairy Products Stores', mcc: '5451' },
      { description: 'Bakeries', mcc: '5462' },
    ],
  },
  {
    broadCategory: 'Service Providers',
    categories: [
      { description: 'Financial Institutions', mcc: '6010' },
      { description: 'Financial Institutions', mcc: '6011' },
      { description: 'Financial Institutions', mcc: '6012' },
      { description: 'Non Financial Institutions', mcc: '6051' },
      { description: 'Securities', mcc: '6211' },
      { description: 'Insurance Sales, Underwriting, and Premiums', mcc: '6300' },
      { description: 'Timeshares', mcc: '7012' },
      { description: 'Recreational and Sporting Camps', mcc: '7032' },
      { description: 'Campgrounds and Trailer Parks', mcc: '7033' },
    ],
  },
  {
    broadCategory: 'Transportation',
    categories: [
      { description: 'Railroads', mcc: '4011' },
      { description: 'Transportation', mcc: '4111' },
      { description: 'Passenger Railways', mcc: '4112' },
      { description: 'Ambulance Services', mcc: '4119' },
      { description: 'Limousines and Taxicabs', mcc: '4121' },
      { description: 'Bus Lines', mcc: '4131' },
      { description: 'Motor Freight Carriers, Trucking', mcc: '4214' },
      { description: 'Courier Services', mcc: '4215' },
      { description: 'Public Warehousing', mcc: '4225' },
      { description: 'Cruise Lines', mcc: '4411' },
      { description: 'Boat Leases and Boat Rentals', mcc: '4457' },
      { description: 'Marinas, Marine Service/Supplies', mcc: '4468' },
      { description: 'Airports, Airport Terminals, Flying Fields', mcc: '4582' },
      { description: 'Travel Agencies and Tour Operators', mcc: '4722' },
      { description: 'Bridge and Road Fees, Tolls', mcc: '4784' },
      { description: 'Transportation Services', mcc: '4789' },
    ],
  },
  {
    broadCategory: 'United Kingdom',
    categories: [
      { description: 'U.K. Supermarkets, Electronic Hot File', mcc: '9751' },
      { description: 'U.K. Petrol Stations, Electronic Hot File', mcc: '9752' },
    ],
  },
  {
    broadCategory: 'Utilities',
    categories: [
      { description: 'Telecommunication Equipment Including Telephone Sales', mcc: '4812' },
      {
        description:
          'Telecommunication Services including but not limited to prepaid phone services and recurring phone services',
        mcc: '4814',
      },
      { description: 'Telegraph Services', mcc: '4821' },
      { description: 'Wire Transfer Money Orders (WTMOs)', mcc: '4829' },
      { description: 'Cable and other Pay Television Services', mcc: '4899' },
      { description: 'Utilities', mcc: '4900' },
    ],
  },
];
